export const userTrackingIDs = {
    periodicControl: {
        id: 'dagligbank-periodic-control',
        updateId: 'dagligbank-update-periodic-control',
    },
    contactInfo: {
        id: 'dagligbank-update-customer-information',
        updateId: 'dagligbank-update-contact-information',
    },
    birthdayConfetti: {
        id: 'dagligbank-birthday-confetti',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy91dGlscy9ndG0vdHJhY2tJRHMvdXNlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsTUFBTSxlQUFlLEdBQUc7SUFDM0IsZUFBZSxFQUFFO1FBQ2IsRUFBRSxFQUFFLDZCQUE2QjtRQUNqQyxRQUFRLEVBQUUsb0NBQW9DO0tBQ2pEO0lBQ0QsV0FBVyxFQUFFO1FBQ1QsRUFBRSxFQUFFLHdDQUF3QztRQUM1QyxRQUFRLEVBQUUsdUNBQXVDO0tBQ3BEO0lBQ0QsZ0JBQWdCLEVBQUU7UUFDZCxFQUFFLEVBQUUsOEJBQThCO0tBQ3JDO0NBQ0osQ0FBQyJ9